import React, { useEffect, useState } from 'react'
import { postData } from '../global/Globalapi'

const ShowReviews = ({product_id}) => {

    const [review_data,setReviewData] = useState([]);

    useEffect(()=>{

        const handleDataFetch = async ()=>{
            try {
                const req = await postData("/get-reviews",{product_id});
                console.log("Data : ",req.data.data);
                setReviewData(req.data.data)
            } catch (error) {
                console.error(error);
            }
        }

        handleDataFetch();
    },[product_id]);

    const renderStars = (rating) => (
    <div className="text-yellow-400 text-base mt-1">
      {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
    </div>
  );


  return (
    <div>
    {/* <h1 className='text-3xl'><strong>Customer Reviews :</strong></h1> */}
      {
        review_data.map((product)=>(
            <>
                <span className='m-5 flex'>
                <section>
                    <img src='https://th.bing.com/th/id/OIP.hGSCbXlcOjL_9mmzerqAbQHaHa?w=197&h=196&c=7&r=0&o=7&pid=1.7&rm=3' className='w-12 h-12'/>
                </section>
                <section>
                    <h1 className='text-xl'>{product.username}</h1>
                     {renderStars(product.star_ratings)}
                <p>{product.comment}</p>
                </section>
            </span>
            <hr />
            </>
        ))
      }
    </div>
  )
}

export default ShowReviews
